var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNotice(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 79,
    height: 79,
    viewBox: "0 0 79 79",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.1113 20.2204C35.1113 18.0573 37.3569 16.3018 40.1272 16.3018C42.8975 16.3018 45.1431 18.0573 45.1431 20.2204V43.7323C45.1431 45.8993 42.8975 47.651 40.1272 47.651C37.3569 47.651 35.1113 45.8993 35.1113 43.7323V20.2204Z",
    fill: "#774F39"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.1272 52.6665C37.3569 52.6665 35.1113 54.9136 35.1113 57.6824C35.1113 60.4511 37.3569 62.6982 40.1272 62.6982C42.8975 62.6982 45.1431 60.4511 45.1431 57.6824C45.1431 54.9136 42.8975 52.6665 40.1272 52.6665Z",
    fill: "#774F39"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5 0C17.6849 0 0 17.6842 0 39.5C0 61.3158 17.6849 79 39.5 79C61.3151 79 79 61.3158 79 39.5C79 17.6842 61.3151 0 39.5 0ZM7.9 39.5C7.9 56.9511 22.0477 71.1 39.5 71.1C56.9523 71.1 71.1 56.9511 71.1 39.5C71.1 22.0489 56.9523 7.9 39.5 7.9C22.0477 7.9 7.9 22.0489 7.9 39.5Z",
    fill: "#774F39"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotice);
export default __webpack_public_path__ + "static/media/notice.8e5337688ce976adc0f7422fcee7cf2b.svg";
export { ForwardRef as ReactComponent };